import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4847b5a8&lang=css"
import "./index.vue?vue&type=style&index=1&id=4847b5a8&scoped=true&lang=css"

import exportComponent from "D:\\web\\userBehavior-course\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4847b5a8"]])

export default __exports__